import React, { useEffect } from "react"
import styled, { keyframes } from "styled-components"
import { media } from "src/styles/breakpoints"
import { Statement } from "src/components/Typography"
import BaseContainer from "src/components/Base/BaseContainer"

const PICS_IO_URL =
  "https://show.pics.io/anima-international-public-resource-library"

const UnderConstruction = () => {
  useEffect(() => {
    window.location.href = PICS_IO_URL
  }, [])

  return (
    <UnderConstructionWrapper>
      <BaseContainer>
        <UnderConstructionContent>
          <Spinner />
          <UnderConstructionMessage>
            Redirecting to our Resource Library...
          </UnderConstructionMessage>
          <FallbackLink href={PICS_IO_URL}>
            Click here if you aren't redirected in 5 seconds
          </FallbackLink>
        </UnderConstructionContent>
      </BaseContainer>
    </UnderConstructionWrapper>
  )
}

const UnderConstructionWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0;

  ${BaseContainer} {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 60vh;
  }

  ${media.tablet} {
    padding: 120px 0;

    ${BaseContainer} {
      min-height: 50vh;
    }
  }

  ${media.desktop} {
    padding: 140px 0;
  }
`

const UnderConstructionContent = styled.div`
  text-align: center;
  max-width: 600px;
  width: 100%;
`

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const Spinner = styled.div`
  width: 50px;
  height: 50px;
  margin: 0 auto 30px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid ${(p) => p.theme.color.primary};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`

const UnderConstructionMessage = styled(Statement)`
  color: ${(p) => p.theme.color.textLight};
`

const FallbackLink = styled.a`
  display: block;
  margin-top: 20px;
  color: ${(p) => p.theme.color.primary};
  text-decoration: underline;
`

export default UnderConstruction
